"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZlList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var ZlList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ZlList, _super);
    function ZlList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金选择交易银行卡接口';
        _this.code = '101059';
        _this.desc = '基金选择交易银行卡接口';
        _this.requestParams = new bankCard_1.ZlListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ZlList;
}(service_1.BaseService));
exports.ZlList = ZlList;
//# sourceMappingURL=zlList.js.map